export default {
    debug: process.env.NODE_ENV !== 'production',
    fallbackLng: 'en',
    supportedLngs: ['en', 'de', 'nl'],
    defaultNS: 'common',
    react: { useSuspense: true },
    returnObjects: true,
  }